import Cookies from 'js-cookie';
import {
  countryList as country,
  purchaseLinks as links,
  editionsList as editions,
  platformsList as platforms,
  comingSoon,
  switchSoon,
  editionsInfo as edition,
} from './purchaselinks_object';

const countriesList = country;
const purchaseLinks = links;
const editionsList = editions;
const platformsList = platforms;
const comingSoonText = comingSoon;
const editionsInfo = edition;

//variables list
const customSelectEdition = document.querySelector('.edition .custom__select');
const selectBtnEdition = document.querySelector(
  '.edition .custom__select__button',
);
const selectedValueEdition = document.querySelector(
  '.edition .custom__select__value',
);
const optionsListEdition = document.querySelectorAll(
  '.edition .custom__select__dropdown li',
);

const customSelectCountry = document.querySelector('.country .custom__select');
const selectBtnCountry = document.querySelector(
  '.country .custom__select__button',
);
const selectedValueCountry = document.querySelector(
  '.country .custom__select__value',
);
const optionsListCountry = document.querySelectorAll(
  '.country .custom__select__dropdown li',
);

const customSelectPlatform = document.querySelector(
  '.platform .custom__select',
);
const selectBtnPlatform = document.querySelector(
  '.platform .custom__select__button',
);
const selectedValuePlatform = document.querySelector(
  '.platform .custom__select__value',
);
const optionsListPlatform = document.querySelectorAll(
  '.platform .custom__select__dropdown li',
);

const customSelectRetailers = document.querySelector(
  '.retailers .custom__select',
);
const selectBtnRetailers = document.querySelector(
  '.retailers .custom__select__button',
);
const selectedValueRetailers = document.querySelector(
  '.retailers .custom__select__value',
);
const optionsListRetailers = document.querySelectorAll(
  '.retailers .custom__select__dropdown li',
);

//setup/change glamshot and text based on edition chosen
const updateGlamAndText = () => {
  const lang = Cookies.get('lang');
  const editionType = Cookies.get('edition');
  const platform = Cookies.get('platform');
  const title = document.querySelector('.purchase__desc__wrapper h2');
  const unorderedList = document.querySelector('.purchase__desc__wrapper ul');
  const isWebpAvailable = document.querySelector('html');
  let itemsToPlace = '';
  const glamshotImages = document.querySelectorAll('.purchase__glamshot img');
  editionsInfo[lang][platform][editionType].title
    ? (title.innerHTML = editionsInfo[lang][editionType].title)
    : (title.innerHTML = '');
  glamshotImages.forEach((glamshot) => {
    if (
      window.innerWidth <= 640 &&
      isWebpAvailable.classList.contains('webp')
    ) {
      // small and webp
      glamshot.src = editionsInfo[lang][platform][editionType].image_640_webp;
    } else if (
      window.innerWidth <= 640 &&
      !isWebpAvailable.classList.contains('webp')
    ) {
      // small and not webp
      glamshot.src = editionsInfo[lang][platform][editionType].image_640;
    } else if (isWebpAvailable.classList.contains('webp')) {
      // large and webp
      glamshot.src = editionsInfo[lang][platform][editionType].image_1280_webp;
    } else {
      // large and not webp
      glamshot.src = editionsInfo[lang][platform][editionType].image_1280;
    }
  });
  if (editionsInfo[lang][platform][editionType].items.length > 0) {
    editionsInfo[lang][platform][editionType].items.forEach((item) => {
      itemsToPlace += `
        <li><strong>${item.title}</strong> ${item.desc}</li>
      `;
    });
    unorderedList.innerHTML = itemsToPlace;
  }
};

window.addEventListener('resize', updateGlamAndText);

//create/update the purchase button
const purchaseBtns = () => {
  const lang = Cookies.get('lang');
  const platform = Cookies.get('platform');
  const edition = Cookies.get('edition');
  const retailer = selectedValueRetailers.textContent;

  const digitalText =
    platform === 'ps5' || platform === 'steam' ? 'wishlist now' : 'coming soon';

  let purchaseHTMLDigital = '';
  let purchaseHTMLPhysical = '';

  /*
   * DIGITAL
   */
  const digitalData = purchaseLinks?.[lang]?.[platform]?.digital?.[edition];

  const hasDigitalLink = digitalData?.link;

  if (edition.includes('digital') && hasDigitalLink) {
    purchaseHTMLDigital = `
  <a 
    class="gtm__purchase" 
    href="${digitalData.link}" 
    target="_blank" 
    data-purchase="${lang} ${edition} ${platform}">
    <h2>${digitalText}</h2>
  </a>
    `;
  } else {
    purchaseHTMLDigital = `
  <a 
    class="gtm__purchase"
    data-purchase="${lang} ${edition} ${platform} ${retailer}">
    <h2>coming soon</h2>
  </a>
    `;
  }

  document.querySelector('.custom__select__platform__button').innerHTML =
    purchaseHTMLDigital;

  /*
   * PHYSICAL
   */
  if (edition.includes('physical')) {
    const retailerList =
      purchaseLinks?.[lang]?.[platform]?.physical?.[edition] || [];

    const retailerData = retailerList.find((obj) => obj.name === retailer);

    const hasPhysicalLink = retailerData?.link;

    if (hasPhysicalLink) {
      purchaseHTMLPhysical = `
        <a 
          class="gtm__purchase" 
          href="${retailerData.link}" 
          target="_blank" 
          data-purchase="${lang} ${edition} ${platform} ${retailer}">

            <h2>pre-order now</h2>
    
        </a>
      `;
    } else {
      purchaseHTMLPhysical = `
  <a 
    class="gtm__purchase"
    data-purchase="${lang} ${edition} ${platform} ${retailer}">
    <h2>coming soon</h2>
  </a>
      `;
    }

    document.querySelector('.custom__select__retailers__button').innerHTML =
      purchaseHTMLPhysical;
  }
};

//handles retailer list showing up and whether button next to platforms shows up if digital edition
const showHideBtns = (edition) => {
  if (edition.includes('digital')) {
    document.querySelector('.retailers').classList.add('retailers__hidden');
    document
      .querySelector('.custom__select__platform__button')
      .classList.remove('btn__hidden');
  } else {
    document.querySelector('.retailers').classList.remove('retailers__hidden');
    document
      .querySelector('.custom__select__platform__button')
      .classList.add('btn__hidden');
  }
};

const resetEdition = () => {
  const lang = Cookies.get('lang');
  const platform = Cookies.get('platform');
  const editionsDropdown = document.querySelector(
    '.edition .custom__select__dropdown',
  );
  if (editionsDropdown) {
    const secondEditionOption = editionsDropdown.querySelectorAll('li')[1];
    if (secondEditionOption) {
      const secondEditionId = secondEditionOption.querySelector('input')?.id;
      const secondEditionLabel =
        secondEditionOption.querySelector('label')?.textContent;

      // Set the label to selected value
      if (secondEditionLabel && selectedValueEdition) {
        selectedValueEdition.textContent = secondEditionLabel;
      }

      // Set cookies for edition and update the UI
      Cookies.set(edition, secondEditionId);
      secondEditionOption.querySelector('input')?.click(); // Simulate a click to select it

      showHideBtns(secondEditionId || ''); // Update any UI elements based on the selected edition
    }
  }
};

//reset so when switching editions, goes back to first platform
const resetPlatform = () => {
  console.log('here');
  const editionType = Cookies.get('edition');
  const currentPlatform = Cookies.get('platform');

  const orderedPlatforms = getOrderedPlatforms();
  console.log(orderedPlatforms);

  orderedPlatforms.forEach((platform) => {
    document
      .getElementById(platform.platform_id)
      .closest('li')
      .classList.remove('hidden');
    document.getElementById(platform.platform_id).closest('input').checked =
      false;
    if (
      (editionType.includes('physical') &&
        !editionType.includes('physicalLimited') &&
        !platform.digitalOnly) ||
      (editionType === 'physicalLimited' && platform.limitedEdition) ||
      editionType.includes('digital') ||
      (platform.digitalDeluxe &&
        (editionType === 'digitalDeluxe' ||
          editionType === 'digitalSuperDeluxe'))
      // platform.digitalUpgrade !== false
    ) {
      document
        .getElementById(platform.platform_id)
        .closest('li')
        .classList.remove('hidden');
    } else {
      document
        .getElementById(platform.platform_id)
        .closest('li')
        .classList.add('hidden');
    }
    // Add additional condition for digitalDeluxe
    if (editionType.includes('digital') && platform.digitalDeluxe === false) {
      if (
        editionType === 'digitalDeluxe' ||
        editionType === 'digitalSuperDeluxe'
      ) {
        document
          .getElementById(platform.platform_id)
          .closest('li')
          .classList.add('hidden');
      }
    }
  });

  const platformCookie = orderedPlatforms[0].platform_cookie;
  Cookies.set('platform', platformCookie);
  const platformId = Cookies.get('platform');

  const label = document.querySelector(`.platform input#${platformId}`)
    ?.nextElementSibling?.textContent;

  if (label) {
    selectedValuePlatform.textContent = label;
  }
  const activeInput = document.getElementById(platformId);

  if (activeInput) {
    activeInput.checked = true;
  }
};

//hide current choices from dropDowns

const hideChoices = () => {
  const country = Cookies.get('lang');
  const edition = Cookies.get('edition');
  const platform = Cookies.get('platform');
  const retailer = document.querySelector(
    '.retailers button .custom__select__value',
  ).textContent;
  const condensedName = retailer.toLowerCase().replace(' ', '_');
  const countryOption = document.querySelector(`.${country}`).closest('li');
  const editionOption = document.querySelector(`#${edition}`).closest('li');
  const platformOption = document.querySelector(`.${platform}`).closest('li');
  const retailerOption = document
    .querySelector(`#${condensedName}`)
    .closest('li');

  const dropdownList = document.querySelectorAll(
    '.custom__select__dropdown li',
  );
  dropdownList.forEach((item) => {
    item.classList.remove('hidden--choice');
  });
  countryOption.classList.add('hidden--choice');
  editionOption.classList.add('hidden--choice');
  platformOption.classList.add('hidden--choice');
  retailerOption.classList.add('hidden--choice');
};

//handles all select choices
const selectBtns = (eventTarget, btn) => {
  const btnCapitalize =
    btn.toLowerCase().charAt(0).toUpperCase() + btn.slice(1);
  const clickedItem = eval(`customSelect${btnCapitalize}`);
  const selectBtnToSet = eval(`selectBtn${btnCapitalize}`);
  if (eventTarget.closest('button')) {
    clickedItem.classList.toggle('active');
    selectBtnToSet.setAttribute(
      'aria-expanded',
      `selectBtn${btnCapitalize}.getAttribute('aria-expanded')` === 'true'
        ? 'false'
        : 'true',
    );
  }
  //using optional chaining here to make sure that if it's the button itself getting clicked an error doesn't get thrown.
  let eventName;
  if (
    eventTarget.closest('li')?.children[0].id &&
    !eventTarget.closest('li')?.children[0].classList.contains('select__option')
  ) {
    eventName = eventTarget.closest('li').children[0].id;
  }
  if (btn.toLowerCase() === 'country' && eventName !== undefined) {
    if (eventName !== 'select__option__country') {
      if (eventName === 'usa') {
        eventName = 'en';
      }
      Cookies.set('lang', eventName);
      const url = new URL(location);
      url.searchParams.set('lang', eventName);
      history.pushState({}, '', url);
      setUpRetailers();
      resetPlatform();
      newOptionsHandler();
      purchaseBtns();
      resetEdition();
      // hideChoices();
    }
  }
  if (btn.toLowerCase() === 'edition' && eventName !== undefined) {
    Cookies.set('edition', eventName);
    showHideBtns(eventName);
    resetPlatform();
    setUpRetailers();
    newOptionsHandler();
    purchaseBtns();
    updateGlamAndText();
    // hideChoices();
  }
  if (btn.toLowerCase() === 'platform' && eventName !== undefined) {
    Cookies.set('platform', eventName);
    if (eventName !== 'select__option__platform') {
      setUpRetailers();
      newOptionsHandler();
      purchaseBtns();
      updateGlamAndText();
      // hideChoices();
    }
  }
  if (btn.toLowerCase() === 'retailers' && eventName !== undefined) {
    purchaseBtns();
    // hideChoices();
  }
};

function closeAllSelect(evt) {
  const customSelectMenu = document.querySelectorAll('.custom__select');
  customSelectMenu.forEach((menu) => {
    if (!menu.contains(evt.target)) {
      menu.classList.remove('active');
    }
  });
}

function newOptionsHandler() {
  const checkOption = document.querySelectorAll(
    '.retailers .custom__select__dropdown li',
  );

  checkOption.forEach((option) => {
    function handler(e) {
      let fromOptionList = e.target.closest('aside').classList[0];
      fromOptionList =
        fromOptionList.charAt(0).toUpperCase() + fromOptionList.slice(1);
      const selectedValue = eval(`selectedValue${fromOptionList}`);
      const customSelect = eval(`customSelect${fromOptionList}`);
      // Click Events
      if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
        selectedValue.textContent = this.children[1].textContent;
        customSelect.classList.remove('active');
      }
      // Key Events
      if (e.key === 'Enter') {
        selectedValue.textContent = this.textContent;
        customSelect.classList.remove('active');
      }
    }
    option.addEventListener('keyup', handler);
    option.addEventListener('click', handler);
  });
}

//sets up handlers, so deals with what happens when the button is clicked, or an option from the menu is chosen
function handlerSetup() {
  const checkTarget = document.querySelectorAll(
    '.edition .custom__select,.country .custom__select, .platform .custom__select, .retailers .custom__select',
  );

  const checkOption = document.querySelectorAll(
    '.edition .custom__select__dropdown li,.country .custom__select__dropdown li, .platform .custom__select__dropdown li, .retailers .custom__select__dropdown li',
  );

  let selectOptions = document.querySelectorAll('.select__option');
  selectOptions = [...selectOptions];

  checkTarget.forEach((item) => {
    function handler(e) {
      selectBtns(e.target, e.target.closest('aside').classList[0]);
    }
    item.addEventListener('click', handler);
  });

  checkOption.forEach((option) => {
    function handler(e) {
      if (!selectOptions.includes(option)) {
        let fromOptionList = e.target.closest('aside').classList[0];
        fromOptionList =
          fromOptionList.charAt(0).toUpperCase() + fromOptionList.slice(1);
        const selectedValue = eval(`selectedValue${fromOptionList}`);
        const customSelect = eval(`customSelect${fromOptionList}`);
        // Click Events
        if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
          selectedValue.textContent = this.children[1].textContent;
          customSelect.classList.remove('active');
        }
        // Key Events
        if (e.key === 'Enter') {
          selectedValue.textContent = this.textContent;
          customSelect.classList.remove('active');
        }
      }
    }
    option.addEventListener('keyup', handler);
    option.addEventListener('click', handler);
  });
  /* if the user clicks anywhere outside the select box,
      then close all select boxes: */
  document.addEventListener('click', closeAllSelect);
}
// using this to show different consoles based on if digital
const getOrderedPlatforms = () => {
  let ordered = [...platformsList];
  let priority = [];

  if (Cookies.get('edition')?.startsWith('digital')) {
    priority = ['steam', 'ps5', 'switch', 'switch2'];
  } else {
    priority = ['switch', 'switch2', 'ps5', 'steam'];
  }
  ordered.sort((a, b) => {
    return priority.indexOf(a.platform_id) - priority.indexOf(b.platform_id);
  });

  return ordered;
};

//creates the editions menu
const setUpEditions = () => {
  const lang = Cookies.get('lang');
  const platform = Cookies.get('platform');
  let editionsHTML = '';
  editionsHTML += `
          <li role="option"  class="select__option">
            <input type="radio" id="select__option__edition" class="select__option" name="edition" disabled />
            <label for="select__option__edition" >Select an Option</label>
        </li>
        `;
  if (editionsList[lang].length !== 0) {
    // if (platform === 'switch2') {
    //   editionsList[lang].unshift();
    // }
    editionsList[lang].forEach((edition) => {
      editionsHTML += `
        <li role="option">
            <input type="radio" id="${edition.edition_id}" name="edition" />
            <label for="${edition.edition_id}">${edition.edition_name}</label>
        </li>
        `;
    });
    document.querySelector('.edition .custom__select__dropdown').innerHTML =
      editionsHTML;
    const editionType = editionsList[lang][0].edition_id;
    Cookies.set('edition', editionType);
    showHideBtns(editionType);
    selectedValueEdition.textContent = document.querySelector(
      '.edition .custom__select .custom__select__dropdown li:nth-child(2) label',
    ).textContent;
  }
};

// creates the countries menu
const setUpCountries = () => {
  let countriesHTML = '';
  countriesHTML += `
  <li role="option"  class="select__option">
    <input type="radio" id="select__option__country" name="edition" disabled />
    <label for="select__option__country">Select an Option</label>
  </li>
  `;
  if (countriesList.length !== 0) {
    countriesList.forEach((country) => {
      countriesHTML += `
          <li role="option">
              <input type="radio" id="${country.country_id}" name="country" class="${country.country_cookie}" />
              <label for="${country.country_id}">${country.country_name}</label>
          </li>
          `;
    });
    document.querySelector('.country .custom__select__dropdown').innerHTML =
      countriesHTML;
  }
  let lang = Cookies.get('lang');
  // selectedValueCountry.textContent = document.querySelector(
  //   '.country .custom__select .custom__select__dropdown li label',
  // ).textContent;
  selectedValueCountry.textContent = document.querySelector(
    `.${lang}`,
  ).nextElementSibling.textContent;
};

//creates the platforms menu
const setUpPlatforms = () => {
  let platformsHTML = '';
  const orderedPlatforms = getOrderedPlatforms();

  platformsHTML += `
    <li role="option"  class="select__option">
      <input type="radio" id="select__option__platform" name="edition" disabled />
      <label for="select__option__platform">Select an Option</label>
    </li>
    `;
  if (orderedPlatforms.length !== 0) {
    orderedPlatforms.forEach((platform) => {
      platformsHTML += `
          <li role="option">
              <input type="radio" id="${platform.platform_id}" name="platform" class="${platform.platform_cookie}" />
              <label for="${platform.platform_id}">${platform.platform_name}</label>
          </li>
          `;
    });
    document.querySelector('.platform .custom__select__dropdown').innerHTML =
      platformsHTML;
    resetPlatform();
  }
};

//creates list of retailers
const setUpRetailers = () => {
  const lang = Cookies.get('lang');
  let platform = Cookies.get('platform');
  const editionType = Cookies.get('edition');
  if (!editionType.includes('digital')) {
    let retailersHTML = '';
    retailersHTML += `
      <li role="option"  class="select__option">
        <input type="radio" id="select__option__retailer" name="edition" disabled />
        <label for="select__option__retailer" >Select an Option</label>
      </li>
      `;
    const retailerList = purchaseLinks[lang][platform]['physical'][editionType];
    //NOTE: need to add the else statment here to deal  with coming soon if retailer links aren't available
    if (retailerList.length !== 0) {
      retailerList.forEach((retailer) => {
        const condensedName = retailer.name.toLowerCase().replace(' ', '_');
        retailersHTML += `
        <li role="option">
          <input type="radio" id="${condensedName}" name="retailers" />
          <label for="${condensedName}">${retailer.name}</label>
        </li>
      `;
      });
    } else {
      retailersHTML = '';
      selectedValueRetailers.textContent = `${comingSoonText[lang]}`;
    }
    document.querySelector('.retailers .custom__select__dropdown').innerHTML =
      retailersHTML;
    if (
      document.querySelector(
        '.retailers .custom__select .custom__select__dropdown li:nth-child(2) label',
      ) !== null
    ) {
      selectedValueRetailers.textContent = document.querySelector(
        '.retailers .custom__select .custom__select__dropdown li:nth-child(2) label',
      ).textContent;
    }
  }
};

//initial set up for purchase area
const selectListSetup = () => {
  setUpEditions();
  setUpCountries();
  setUpPlatforms();
  setUpRetailers();
  purchaseBtns();
  handlerSetup();
  updateGlamAndText();
  // hideChoices();
};

selectListSetup();
